module.exports = __webpack_public_path__ + "static/media/5DPO21.b9817a15.jpg";